const accordionInit = (accordion: HTMLElement) => {
  const title = accordion.querySelector('.accordion__title');

  if (
    window.matchMedia('(min-width: 640px)').matches
    && accordion.classList.contains('product-archive__item')
  ) {
    accordion.classList.toggle('accordion--open');
  }

  title.addEventListener('click', () => {
    accordion.classList.toggle('accordion--open');
  });
};

export default accordionInit;
